import { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { getNameInitials } from '#client/utils/formatString';

import * as Styled from './SocialProof.styles';

function SocialProof({ image, alt = '', testimonial = {} }) {
  const { quote, source, author } = testimonial;
  const { formatMessage } = useIntl();

  const testimonialRef = useRef(null);

  const [testimonialHeight, setTestimonialHeight] = useState(0);

  useEffect(() => {
    if (testimonialRef.current) {
      setTestimonialHeight(testimonialRef.current.offsetHeight);
    }
  }, []);

  return (
    <Styled.SocialProofContainer testimonialHeight={testimonialHeight}>
      <Styled.SocialProofImageContainer>
        <Styled.SocialProofImage alt={alt ? formatMessage({ id: alt }) : alt} src={image} />
      </Styled.SocialProofImageContainer>

      <Styled.TestimonialCard size="lg" ref={testimonialRef}>
        <Styled.AuthorAvatar>
          <Text size="xl" weight="medium" color="primary">
            {getNameInitials(formatMessage({ id: author }))}
          </Text>
        </Styled.AuthorAvatar>
        <Box>
          <Text size="2xl" weight="bold" family="secondary">
            “
          </Text>
          <Stack gap={2}>
            <Text size="md">
              <FormattedMessage id={quote} />
            </Text>
            <Text size="md" weight="medium">
              {`${formatMessage({ id: author })} ${formatMessage({ id: source })}`}
            </Text>
          </Stack>
        </Box>
      </Styled.TestimonialCard>
    </Styled.SocialProofContainer>
  );
}

SocialProof.propTypes = {
  image: PropTypes.string.isRequired,
  alt: PropTypes.string,
  testimonial: PropTypes.shape({
    quote: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
  }),
};

export default SocialProof;
